import { Anteroom } from 'ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const ContentInfo = ({
  title,
  duration,
  body,
  audios,
  subtitles
}) => {

  const { t } = useTranslation()

  const durationText = `${duration} min`

  const getSubtitles = () => {
    const allSubs = subtitles.map( sub => sub.lang)
    const setSubs = new Set(allSubs)
    const sortFn = (first, last) => first.localeCompare(last)
    return Array.from(setSubs).sort(sortFn).join(', ')
  }

  const subtitlesText = getSubtitles()


  return (
    <>
      <Anteroom.HeadlineMedium>{title}</Anteroom.HeadlineMedium>

      <Anteroom.Divider.Root>
        <Anteroom.Divider.Child>{durationText}</Anteroom.Divider.Child>
        <Anteroom.Divider.Child>{t('audio')} ({audios})</Anteroom.Divider.Child>

        { subtitlesText && (
          <Anteroom.Divider.Child>
            {t('subtitles')} ({subtitlesText})
          </Anteroom.Divider.Child>
        )}
      </Anteroom.Divider.Root>

      <Anteroom.Body>{body}</Anteroom.Body>
    </>
  )
}
